var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer",attrs:{"id":"footer"}},[_c('div',{staticClass:"copyright"},[_vm._v(" © Copyright "),_c('strong',[_c('span',[_vm._v("Fastana Logistik Indonesia")])]),_vm._v(". ")])])
}]

export { render, staticRenderFns }